module.exports = __webpack_public_path__ + "static/media/icono-w.dcee1231.svg";